export default __webpack_public_path__ + "static/media/AlertIcon.f19f8d5e.svg";